import { render } from "./com_app_instalacion.vue?vue&type=template&id=be573a84&scoped=true"
import script from "./com_app_instalacion.vue?vue&type=script&lang=js"
export * from "./com_app_instalacion.vue?vue&type=script&lang=js"

import "./com_app_instalacion.vue?vue&type=style&index=0&id=be573a84&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be573a84"]])

export default __exports__